import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CardActions from '@mui/material/CardActions';
import { Link } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './ColorTheme';

export default function OfferCard() {
  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Card
          sx={{
            maxWidth: 345,
            borderRadius: '16px',
            overflow: 'hidden',
            transition: 'all 0.3s ease',
            '&:hover': {
              transform: 'translateY(-8px)',
              boxShadow: '0 12px 24px rgba(75, 148, 156, 0.25)',
            }
          }}
          raised
        >
          <CardMedia
            component="img"
            height="180"
            image="offer.png"
            alt="Gourmetessen Bären"
            sx={{
              objectFit: 'cover',
            }}
          />
          <CardContent sx={{ padding: '24px' }}>
            <Typography
              gutterBottom
              variant="subtitle1"
              component="div"
              sx={{
                fontWeight: 600,
                fontSize: '18px',
                color: '#324b4e',
                marginBottom: '12px'
              }}
            >
              🎉 Dein Vorteil: 10% Rabatt bei Online-Reservierung!
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: 'text.secondary',
                lineHeight: 1.7,
                fontSize: '15px'
              }}
            >
              Reserviere eines unserer Genussmenüs online und sichere dir 10% Rabatt auf den Menüpreis!
            </Typography>
          </CardContent>
          <CardActions
            sx={{
              display: 'flex',
              justifyContent: 'center',
              paddingBottom: 3,
              paddingTop: 1,
            }}
          >
            <Button
              component={Link}
              to="/reservation"
              variant="contained"
              color="baerendark"
              size="large"
              sx={{
                borderRadius: '24px',
                padding: '10px 32px',
                fontSize: '16px',
                fontWeight: 600,
                textTransform: 'none',
                boxShadow: '0 4px 12px rgba(50, 75, 78, 0.25)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  boxShadow: '0 6px 20px rgba(50, 75, 78, 0.35)',
                  transform: 'translateY(-2px)',
                }
              }}
            >
              Jetzt reservieren!
            </Button>
          </CardActions>
        </Card>
      </Box>
    </ThemeProvider>
  );
}
